import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const STUDIO_TOKEN_KEY = "zebo_studio_token";

export const studioApi = axios.create({ baseURL: API });

studioApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(STUDIO_TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
